import React, { Component } from "react";
import _ from "lodash";
import { Table } from "semantic-ui-react";

class AliasesDetailNimbus extends Component {
  componentDidMount() { }

  render() {
    const rows = [];
    const node = this.props.node;
    if (node !== undefined && node.AKAs !== undefined) {
      _.forEach(node.AKAs[0].AKA, (alias, index) => {
        const fullName = `${_.get(alias, "name[0].firstName[0]._", "")} ${_.get(
          alias,
          "name[0].middleName[0]._",
          ""
        )} ${_.get(alias, "name[0].lastName[0]._", "")}`;
        rows.push(
          <Table.Row key={`alias_${index}`}>
            <Table.Cell>NAME:</Table.Cell>
            <Table.Cell>{fullName}</Table.Cell>
          </Table.Row>
        );
      });
    }

    return (
      <Table>
        <Table.Body>
          <Table.Row className="report-sub-section-header">
            <Table.HeaderCell colSpan={4}>
              Aliases/A.K.A Used by Subject
            </Table.HeaderCell>
          </Table.Row>
          {rows}
        </Table.Body>
      </Table>
    );
  }
}

export default AliasesDetailNimbus;



// WEBPACK FOOTER //
// ./src/components/reports/AliasesDetailNimbus.js